import { addToCartApi } from "../../../redux/api/website/Addtocartapi";
import { cartProductCount } from "../../../redux/reduxApi/website/CartProductCount";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";

import { toast } from "react-toastify";

function getOrCreateGuestId() {
  let guestId = Cookies.get("guest_id");
  if (!guestId) {
    guestId = uuidv4();
    Cookies.set("guest_id", guestId, { expires: 7 }); // cookie lasts 7 days
  }
  return guestId;
}
export const AddToCart = async (product, quantity) => {
  console.log("productutils", product, quantity);

  const userId = localStorage.getItem("customerId");

  if (!userId) {
    // Guest user flow
    const guestId = getOrCreateGuestId();
    const newCartData = {
      guestId: guestId,
      uniqueSerialNo: product.uniqueKey,
      part_key: product.part_key,
      quantity: quantity || 1,
      price: product.sellingPrice,
      image: product.image|| "",
      name: product.part_type || "",
    };
    try {
      const response = await addToCartApi(newCartData);
      if (response.data.success) {
        toast.success("Product added to cart successfully");
        // cartProductCount();
        return response.data;
      }
    } catch (error) {
      console.error("Error adding product to cart:", error);
    }

    return;
  }
  let guestId;
  if (!userId) {
    // 🔐 Logged-in user flow
    guestId = getOrCreateGuestId();
  }
  const newCartData = {
    guestId: guestId,
    uniqueSerialNo: product.uniqueKey,
    customerId: userId,
    part_key: product.part_key.toString(),
    quantity: quantity || 1,
    price: product.sellingPrice,
    height: product.height || "",
    width: product.width || "",
    length: product.length || "",
    weight: product.weight || "",
    image: product.image || "",
    name: product.part_type || "",
  };

  try {
    const response = await addToCartApi(newCartData);
    if (response.data) {
    }
    if (response.data.success) {
      toast.success("Product added to cart successfully");
      return response.data;
    }
  } catch (error) {
    console.error("Error adding product to cart:", error);
  }
};
